import {
  Flex, Table, TableRootProps
} from '@huspy/briks-web';
import { RefAttributes } from 'react';
import { JSX } from 'react/jsx-runtime';
import SortArrowIcon from '@icons/SortArrowIcon';
import { Skeleton } from '@mantine/core';
import briksTableStyles from './styles';

const {
  root, head, header, cell,
} = briksTableStyles;

const Root = (props: JSX.IntrinsicAttributes & TableRootProps & RefAttributes<HTMLTableElement>) =>
  <Table.Root { ...props } className={ root } />;

const Head = (props: React.ComponentProps<typeof Table.Head>) => <Table.Head { ...props } className={ head } />;
const Row = (props: React.ComponentProps<typeof Table.Row>) => <Table.Row { ...props } className={ cell } />;
const Body = (props: React.ComponentProps<typeof Table.Body>) => <Table.Body { ...props } />;
const Cell = (props: React.ComponentProps<typeof Table.Cell>) => (
  <Table.Cell
    // eslint-disable-next-line react/destructuring-assignment
    py={ props.py ?? '6' }
    // eslint-disable-next-line react/destructuring-assignment
    px={ props.px ?? '4' }
    { ...props }
    className={ cell }
  />
);
const Header = (props: React.ComponentProps<typeof Table.Header>) => (
  <Table.Header
    className={ header }
    // eslint-disable-next-line react/destructuring-assignment
    p={ props.p ?? '4' }
    { ...props }
  />
);

const SORTING_ORDER = ['ASC', 'DESC'] as const;

type SortOrder = typeof SORTING_ORDER[number];

const SortableHeader = ({
  onClick, isSortedByThis, order, children, ...rest
}: {
  onClick(): void;
  isSortedByThis: boolean;
  order?: SortOrder | string;
} & React.ComponentProps<typeof Header>) => (
  <Header cursor='pointer' onClick={ onClick } { ...rest }>
    <Flex align='center' gap={ 2 }>
      {children}
      {isSortedByThis ? (
        <SortArrowIcon
          isActive
          isRotated={ order === 'DESC' }
        />
      ) : (
        <Flex gap={ 0.5 } direction='column'>
          <SortArrowIcon />
          <SortArrowIcon isRotated />
        </Flex>
      )}
    </Flex>
  </Header>
);

const Loading = (
  { rows = 6, cells = 5 }: { rows?: number, cells?: number }
) => new Array(rows).fill(0).map((_, idx1) => (
  // eslint-disable-next-line react/no-array-index-key
  <Table.Row key={ `table-loading-row-${idx1}` }>
    {new Array(cells).fill(0).map((__, idx2) => (
      // eslint-disable-next-line react/no-array-index-key
      <Table.Cell key={ `table-loading-cell-${idx2}` }>
        <Skeleton height={ 30 } w='100%' radius='4px' />
      </Table.Cell>
    ))}
  </Table.Row>
));

const BriksTable = {
  Root,
  Head,
  Header,
  Row,
  Body,
  Cell,
  SortableHeader,
  Loading,
};

export default BriksTable;
